import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/overview.png'
import _imports_1 from '@/assets/overbg.png'


const _withScopeId = n => (_pushScopeId("data-v-1399bfb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview d-flex flex-column flex-md-row" }
const _hoisted_2 = { class: "overview-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Get Zero-interest Loan in 5mins.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" withHalal, access upto "),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"#0066f4"} }, "3X"),
  /*#__PURE__*/_createTextVNode(" of your savings with no interest. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" No-collatera, just a good credit score, impressive cash flow and business credibility. ")
], -1))
const _hoisted_5 = {
  href: "https://play.google.com/store/apps/details?id=com.withhalal.withhalalmobile",
  icon: "facebook",
  target: "_blank",
  title: ""
}
const _hoisted_6 = { class: "overview-right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-100",
  alt: "overview"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute overview-right-bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-100",
    alt: "overview"
  })
], -1))
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "text-decoration-underline mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.dClass)
      }, [
        _createElementVNode("a", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadsgoogle, (download) => {
            return (_openBlock(), _createBlock(_component_Button, {
              key: download.head,
              iconed: "",
              icon: download.icon,
              head: download.head,
              foot: download.foot
            }, null, 8, ["icon", "head", "foot"]))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadsapple, (download) => {
          return (_openBlock(), _createBlock(_component_Button, {
            key: download.head,
            iconed: "",
            icon: download.icon,
            head: download.head,
            foot: download.foot,
            onClick: _ctx.countdown
          }, null, 8, ["icon", "head", "foot", "onClick"]))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loans, (loan) => {
        return (_openBlock(), _createElementBlock("div", {
          key: loan.id,
          class: _normalizeClass([`overview-loan-${loan.id}`, "position-absolute overview-loan"])
        }, [
          _createElementVNode("h4", null, _toDisplayString(loan.heading), 1),
          _createElementVNode("p", _hoisted_9, "Halal tag: " + _toDisplayString(loan.name), 1),
          _createElementVNode("p", _hoisted_10, "Amount: #" + _toDisplayString(loan.amount), 1),
          _createElementVNode("p", _hoisted_11, " Balance : " + _toDisplayString(loan.balance), 1)
        ], 2))
      }), 128))
    ])
  ]))
}